import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { getParkingSessionStatus, parkingSessionClose, parkingSessionCreate } from 'services/payments-service';
import { Toggle, Loader2, Error } from 'libs/ui';
import { ToggleWrapper } from './parking-session.styled';

/**
 * Сохранение выбранного в ParkingSession состояния (вызывается формой после успешного сохранения)
 * @param {{loaded: boolean, checked: boolean, initialChecked: boolean, stayId: string|null}|null} state
 * @param {string} meanId
 * @param {string} meanType
 * @returns {Promise}
 */
export const saveParkingSession = (state, meanId, meanType) => {
  if (!state || !state.loaded || state.checked === state.initialChecked) {
    return Promise.resolve();
  }
  const request = state.checked ? parkingSessionCreate(meanId, meanType) : parkingSessionClose(state.stayId);
  return request.catch((error) => {
    const prefix = state.checked ? 'Ошибка создания парковочной сессии' : 'Ошибка закрытия парковочной сессии';
    throw new window.Error(`${prefix}: ${error?.message ?? error}`);
  });
};

export const ParkingSession = (props) => {
  const { t } = useTranslation();

  const { meanId, meanType, onChange: onStateChange } = props;
  const [checked, setChecked] = useState(false);
  const [stayId, setStayId] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    getParkingSessionStatus(meanId, meanType)
      .then((result) => {
        setChecked(true);
        setStayId(result.id);
        onStateChange?.({ loaded: true, checked: true, initialChecked: true, stayId: result.id });
      })
      .catch((error) => {
        if (error.code === 200) {
          setError(null);
          setChecked(false);
          onStateChange?.({ loaded: true, checked: false, initialChecked: false, stayId: null });
        } else {
          setError(error?.message?.toString());
        }
      });
  }, []);

  const onChange = (event) => {
    const newChecked = event.target.checked;
    setChecked(newChecked);
    onStateChange?.({ loaded: true, checked: newChecked, initialChecked: stayId !== null, stayId });
  };

  if (checked === null && error === null) {
    return <Loader2 height={'40px'} />;
  }

  return (
    <ToggleWrapper>
      {error ? (
        <Error>Ошибка получения ПС: {error}</Error>
      ) : (
        <Toggle label={t('form.Парковочная сессия активна')} value={checked} onChange={onChange} checked={checked} />
      )}
    </ToggleWrapper>
  );
};

ParkingSession.propTypes = {
  meanId: PropTypes.string.isRequired,
  meanType: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};
